import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    borderRadius: 8,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  icon: {
    color: theme.palette.primary.main,
  },
  title: {
    fontWeight: 600,
    color: theme.palette.grey[800],
  },
}));
